"use strict";
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentStatus = void 0;
/**
 * An enumeration.
 */
var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["OUTSTANDING"] = "Outstanding";
    PaymentStatus["CASHED"] = "Cashed";
    PaymentStatus["PAID"] = "Paid";
    PaymentStatus["CREDITED"] = "Credited";
    PaymentStatus["CANCELLED"] = "Cancelled";
    PaymentStatus["UNDER_INVESTIGATION"] = "Under investigation";
    PaymentStatus["PENDING"] = "Pending";
    PaymentStatus["FAILED"] = "Failed";
    PaymentStatus["ON_HOLD"] = "On hold";
})(PaymentStatus = exports.PaymentStatus || (exports.PaymentStatus = {}));
